import dayjs from 'dayjs';

export const nextDeliveryDate = (disableWeek: boolean[], nextBillingDate: Date, deliveryDays: number) => {
  let nextDelivery = dayjs(nextBillingDate).add(deliveryDays, 'day');

  if (!disableWeek.every((v) => v)) {
    const disableDays = disableWeek.slice(nextDelivery.day()).concat(disableWeek.slice(0, nextDelivery.day()));
    nextDelivery = nextDelivery.add(
      disableDays.findIndex((v) => !v),
      'days'
    );
  }

  return nextDelivery.toDate();
};
